import React, { Component } from "react";
import reactCSS from "reactcss";
import { SingleDatePicker, DateRangePicker } from "react-dates";
import PropTypes from "prop-types";

import "react-dates/lib/css/_datepicker.css";
import "../index.css";
import "./date-picker.css";

class DatePicker extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    placeholders: PropTypes.array,
    disabled: PropTypes.bool,
    numberOfMonths: PropTypes.number,
    fullWidth: PropTypes.bool,
    modal: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.any,
    startDate: PropTypes.any,
    endDate: PropTypes.any,
    onChange: PropTypes.func,
    multiple: PropTypes.bool,
    errorText: PropTypes.string
  };

  static defaultProps = {
    placeholder: "Selecionar",
    placeholders: ["Data Inicial", "Data Final"],
    numberOfMonths: 1,
    fullWidth: false,
    modal: false,
    multiple: false,
    disabled: false,
    errorText: ""
  };

  constructor(props) {
    super(props);

    this.state = {
      date: this.props.date || null,
      startDate: this.props.startDate || null,
      endDate: this.props.endDate || null,
      focused: null,
      focusedInput: null,
      error: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorText === "") {
      this.setError(false);
    } else {
      this.setError(true);
    }
  }

  setError(value) {
    this.setState({
      error: value
    });
  }

  handleOnChange = date => {
    this.setState({ date });

    if (this.props.disabled) {
      return;
    }

    if (this.props.onChange) {
      this.props.onChange(date);
    }
  };

  handleMultipleOnChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });

    if (this.props.disabled) {
      return;
    }

    if (this.props.onChange) {
      this.props.onChange({ startDate, endDate });
    }
  };

  handleClearButton = async () => {
    if (!this.props.multiple) {
      this.handleOnChange(null);
    } else {
      this.handleMultipleOnChange({ startDate: null, endDate: null });
    }
  };

  getLabel() {
    return this.props.label || false;
  }

  getElement() {
    if (this.props.multiple) {
      return (
        <DateRangePicker
          minimumNights={0}
          startDate={this.props.startDate || this.state.startDate}
          endDate={this.props.endDate || this.state.endDate}
          hideKeyboardShortcutsPanel
          startDatePlaceholderText={this.props.placeholders[0]}
          endDatePlaceholderText={this.props.placeholders[1]}
          monthFormat="MMMM YYYY"
          displayFormat="DD/MM/YYYY"
          numberOfMonths={this.props.numberOfMonths}
          onDatesChange={({ startDate, endDate }) =>
            this.handleMultipleOnChange({ startDate, endDate })
          }
          focusedInput={this.state.focusedInput}
          isOutsideRange={() => false}
          withPortal={this.props.modal}
          onFocusChange={focusedInput => this.setState({ focusedInput })}
          disabled={this.props.disabled}
          onClose={this.props.onClose}
        />
      );
    }

    return (
      <SingleDatePicker
        hideKeyboardShortcutsPanel
        placeholder={this.props.placeholder}
        monthFormat="MMMM YYYY"
        displayFormat="DD/MM/YYYY"
        numberOfMonths={this.props.numberOfMonths}
        date={this.props.date || this.state.date}
        onDateChange={date => this.handleOnChange(date)}
        focused={this.state.focused}
        isOutsideRange={() => false}
        withPortal={this.props.modal}
        onFocusChange={({ focused }) => this.setState({ focused })}
        disabled={this.props.disabled}
        onClose={this.props.onClose}
      />
    );
  }

  render() {
    const styles = reactCSS(
      {
        fullWidth: {
          field: {
            width: "100%"
          }
        },
        disabled: {
          field: {
            opacity: 0.8
          },
          input: {
            cursor: "not-allowed"
          }
        },
        error: {
          element: {
            border: "none"
          },
          label: {
            color: "#FF0014"
          }
        },
        default: {
          field: {
            display: "inline-block",
            width: 256,
            boxSizing: "border-box",
            position: "relative",
            marginTop: 12
          },
          label: {
            width: "100%",
            fontWeight: "bold",
            fontFamily: "Source Sans Pro",
            fontSize: "0.8em",
            marginBottom: 4,
            cursor: "pointer",
            color: "#222"
          },
          input: {
            width: "100%"
          },
          errorText: {
            color: "#FF0014",
            marginTop: 0,
            paddingTop: "0.4em",
            fontSize: "0.6em",
            fontFamily: "Source Sans Pro",
            whiteSpace: "pre-line"
          },
          clearButton: {
            width: "32px",
            height: "32px",
            position: "absolute",
            right: "15px",
            bottom: "15px",
            cursor: "pointer"
          }
        },
        noMargin: {
          field: {
            marginTop: 0
          }
        }
      },
      this.props,
      this.state
    );

    return (
      <div className="date-picker" style={styles.field}>
        <label>
          {this.getLabel() && (
            <div className="date-picker--label" style={styles.label}>
              {this.getLabel()}
            </div>
          )}
          <div className="date-picker--element">
            {this.getElement()}
            {this.props.errorText.length > 0 && (
              <p className="error-text-message" style={styles.errorText}>
                {this.props.errorText}
              </p>
            )}
          </div>
        </label>
      </div>
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/support/date-picker/index.jsx